module.exports = __webpack_public_path__ + "static/media/NavMenuDesktop.a58f6200.png";